import {GameStateEnums} from '../../../../shared/GameEnums.ts'
import {type UIGameMechanic} from './UIGameEventController.ts'
import {type UIGameManager} from './UIGameManager.ts'
import {Sound} from '../Sound.ts'
import {ActionState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameTurnSoundController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private oldState: TurnState

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.oldState = TurnState.InitialPlacement
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: this.playTurnSound(); break
            default: break
        }
        this.oldState = this.uiGameManager.gameController.currentState.turnState
    }

    private playTurnSound() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.None) return
        if(this.uiGameManager.gameController.currentState.turnState == this.oldState) return
        if(!this.uiGameManager.gameController.isMyTurn) return

        if(this.statesToPlayTurnSound()) Sound.playSound(Sound.SoundType.YourTurn)
    }

    private statesToPlayTurnSound(): boolean {
        if(this.uiGameManager.gameController.isReplay) return false
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Dice) return true

        return false
    }
}
